<template>
    <v-container fill-height>
        <v-dialog persistent v-model="showLoginDialog" max-width="300px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        <h2 class="headline">Dekkhotell: Logg inn</h2>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-form @keypress.native.enter="login" class="pt-2">
                        <v-text-field label="Epost" v-model="email" required
                                      :error-messages="errors.email">
                        </v-text-field>
                        <v-text-field label="Passord" v-model="password" type="password" required
                                      :error-messages="errors.password">
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-divider/>
                <v-card-text class="py-0">
                    <v-layout align-center>
                        <v-flex>
                            <v-checkbox v-model="remember" label="Husk meg"/>
                        </v-flex>
                        <v-flex>
                            <v-btn large block color="primary" :loading="loading" @click="login">Logg inn</v-btn>
                        </v-flex>
                    </v-layout>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                showLoginDialog: true,
                loading: false,

                email: '',
                password: '',
                remember: false,

                errors: {}
            };
        },

        created() {
            this.loading = true;
            this.$http.get('user').then(response => {
                this.$router.push({name: 'CustomerIndex'})
            }).finally(() => {
                this.loading = false;
            });
        },

        methods: {
            login() {
                this.$http.post('/auth/login', {
                    email: this.email,
                    password: this.password,
                    remember: this.remember
                }).then(response => {
                    this.$router.push({name: 'CustomerIndex'});
                }).catch(error => {
                    this.errors = error.response.data.errors
                });
            }
        }
    }
</script>

